import { useState } from "react";
import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";

export function useConfirmDialog() {
    const [open, setOpen] = useState(false);
    const [question, setQuestion] = useState<string>("Czy na pewno?");
    const [resolve, setResolve] = useState<((result: boolean) => void) | null>(null);

    const confirm = (customQuestion: string) =>
        new Promise<boolean>((res) => {
            setQuestion(customQuestion);
            setResolve(() => res);
            setOpen(true);
        });

    const handleClose = (result: boolean) => {
        setOpen(false);
        resolve?.(result);
    };

    const dialog = (
        <Dialog open={open} onClose={() => handleClose(false)}>
            <DialogTitle>{question}</DialogTitle>
            <DialogActions>
                <Button
                    onClick={() => handleClose(false)}
                    color="primary"
                    onPointerDown={e => e.stopPropagation()}
                >
                    Nie
                </Button>
                <Button
                    onClick={() => handleClose(true)}
                    color="primary"
                    autoFocus
                    onPointerDown={e => e.stopPropagation()}
                >
                    Tak
                </Button>
            </DialogActions>
        </Dialog>
    );

    return { confirm, dialog };
}